export class SuspendedError extends Error {
    constructor(error: Error) {
        super(error.message)
        this.cause = error.cause
        this.name = "SuspendedError"
        Object.setPrototypeOf(this, SuspendedError.prototype)
    }
}
